import { render, staticRenderFns } from "./IconWavePulse.vue?vue&type=template&id=61818bcc&functional=true&"
import script from "./IconWavePulse.vue?vue&type=script&lang=js&"
export * from "./IconWavePulse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports